import { TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL } from "@shared/utils/constants";
import { Disclaimer } from "./MessageBar/styles";

export const DisclaimerFooter = () => {
  return (
    <Disclaimer variant="body2">
      Sidekick may produce inaccurate information.{" "}
      <a
        href={TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Notice.
      </a>
    </Disclaimer>
  );
};
